import React, { Component } from 'react'

import Grid from '@material-ui/core/Grid'

import Footer from '../components/Footer/Footer'
import Link from '../components/Link/Link'
import Whitespace from '../components/Whitespace'

import PostsService from '../services/Posts'
import Request from '../services/Request/Request'

class Post extends Component {
	state = {
		page: {
			title: null,
			nodes: []
		},
		meta: {
			title: null,
			description: null,
			canonical: null,
			meta: {
				charset: 'utf-8',
				name: {
					keywords: null
				}
			}
		},
		post: {
			title: null,
			image: null,
			body: null,
		},
		nodes: []
	}

	constructor (props) {
		super(props)

		const { match } = this.props

		Request.get(`/pages/post`)
			.then(page => {
				page.nodes = page.nodes.reduce(function (nodes, node) {
					nodes[node.slug] = node.value
					return nodes
				}, {})
				this.setState({
					page: page,
					meta: {
						title: `${page.metaTitle} • Thetis`,
						description: page.metaDescription,
						canonical: page.canonical,
						meta: {
							charset: 'utf-8',
							name: {
								keywords: page.metaKeywords
							}
						}
					}
				})
				document.title = `Thetis • ${this.state.page.title}`
			})
			.catch(err => {
				console.error(err)
			})

		PostsService.get(match.params.postSlug, {
			populate: ['image']
		})
			.then(post => {
				console.log(post)
				if (post) {
					this.setState({
						post: post
					})
				}
			})
			.catch(err => {
				console.error(err)
			})
	}

	render() {
		return (
			<div>
				{this.state.post.image ? <div style={{
					background: `url(${this.state.post.image.uri})`,
					backgroundPosition: 'center center',
					height: '30vh',
					width: '100vw'
				}}></div> : <Whitespace padding="5rem 0" />}
				<Grid container justify="center" style={{ padding: '3rem 0 5rem' }}>
					<Grid item xs={12} sm={9}>
						<h1>{this.state.post.title}</h1>
						<p>{this.state.post.body}</p>
						<div>
							<Link href="/#news">Back to the home page</Link>
						</div>
					</Grid>
				</Grid>
				<Footer nodes={this.state.page.nodes} />
			</div>
		)
	}
}

export default Post


// WEBPACK FOOTER //
// ./src/pages/Post.js